// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel-item_root__o_8_M","snapStart":"carousel-item_snapStart__jHMkC","snapEnd":"carousel-item_snapEnd__lDwHq"};